import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Field, Form, Formik } from 'formik';

import { Box, Card } from '@mui/material';

import {
  Button,
  FileUpload,
  Page,
  useFilterConfig,
  usePanelState,
  useTableQueryParams,
} from 'components';
import { getPageName } from 'utils/format';
import { RouteNames } from 'config/routeNames';
import { useUploadDocuments } from 'features/uploadDocuments';

const styles = {
  uploadCard: {
    p: 2,
    borderRadius: '8px',
    '@media (min-width: 1600px)': {
      width: '35%',
    },
    '@media (max-width: 1599px)': {
      width: '45%',
    },
  },
};

const UploadDocumentsPage: FC = () => {
  const { onFilter, onLoadQuery, params } = useTableQueryParams();

  const { mutateAsync: uploadDocuments, isPending: isLoading } = useUploadDocuments();

  const filterConfig = useFilterConfig({
    params,
    onFilter,
    onLoad: onLoadQuery,
    isButton: true,
    pageName: getPageName(RouteNames.KOZOS_DOKUMENTUM_FELTOLTES),
  });

  const { activePanel, closePanel, setPanel } = usePanelState();

  const panels = [filterConfig];

  return (
    <Page
      title={<Trans i18nKey="KOZOS_DOKUMENTUM_FELTOLTES.TITLE" />}
      inScroll
      panels={panels}
      activePanel={activePanel}
      closePanel={closePanel}
      setPanel={setPanel}
    >
      <Card elevation={1} sx={styles.uploadCard}>
        <Formik
          initialValues={{ file: null }}
          onSubmit={(values, { resetForm }) => {
            uploadDocuments(values?.file?.[0]);
            resetForm();
          }}
        >
          {({ values, resetForm }) => (
            <Form>
              <Field
                label={<Trans i18nKey="KOZOS_DOKUMENTUM_FELTOLTES.FILE_LABEL" />}
                component={FileUpload}
                multiple={false}
                onDropRejected={resetForm}
                name="file"
                accept={{
                  'application/json': ['.zip'],
                }}
              />
              <Box mt={2}>
                <Button type="submit" disabled={!values.file} loading={isLoading}>
                  <Trans i18nKey="KOZOS_FELADAT_IMPORT.IMPORT_BUTTON" />
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Card>
    </Page>
  );
};

export default UploadDocumentsPage;
